import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Switch } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import dayjs from "dayjs"
import AdminTable from "../Helpers/AdminTable"
import { getLockerActions } from "src/store/Slices/Administrator/LockersSlice"

const ACTION_TITLES = {
  pulse: "Импульс на открытие",
  rent_start: "Начало аренды",
  rent_end: "Конец аренды",
}

const FALLBACK_COLUMNS = {
  data: {
    value: {
      columns: [
        { title: "№", dataIndex: "id" },
        { title: "Шкафчик", dataIndex: "lockerId" },
        { title: "Номер", dataIndex: "lockerNumber" },
        { title: "Клуб", dataIndex: "clubName" },
        { title: "Клиент", dataIndex: "userId" },
        { title: "Телефон", dataIndex: "userPhone" },
        { title: "Команда", dataIndex: "action" },
        { title: "Действие", dataIndex: "actionTitle" },
        { title: "Статус", dataIndex: "status" },
        { title: "Ошибка", dataIndex: "error" },
        { title: "Дата", dataIndex: "dateCreate" },
      ],
    },
  },
}

const statusLabel = (status) => {
  if (status === 1 || status === "1") return "Успех"
  if (status === 0 || status === "0") return "Ошибка"
  return status ?? ""
}

const LockerActions = () => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [isDeleted, setIsDeleted] = useState(false)
  const [tableFilters, setTableFilters] = useState({})

  const list = useSelector((state) => state.LockersSlice.lockerActionsList)
  const loading = useSelector(
    (state) => state.LockersSlice.lockerActionsListLoading,
  )

  const load = (
    nextPage = page,
    nextPageSize = pageSize,
    filters = tableFilters,
    deleted = isDeleted,
  ) => {
    dispatch(
      getLockerActions({
        isDeleted: deleted,
        count: nextPageSize,
        offset: nextPageSize * (nextPage - 1),
        ...filters,
      }),
    )
  }

  useEffect(() => {
    load(1, 20, {}, false)
  }, [])

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (!keys || !values) return formattedItems
    keys.forEach((key, index) => {
      const selected = values[index]
      if (selected == undefined) return
      if (key === "id") {
        if (selected[0] !== undefined && selected[0] !== "") {
          formattedItems.idFrom = selected[0]
        }
        if (selected[1] !== undefined && selected[1] !== "") {
          formattedItems.idTo = selected[1]
        }
      } else if (key === "clubName" || key === "clubId" || key === "club") {
        if (selected[0] != undefined) formattedItems.clubId = selected[0]
      } else if (
        key === "lockerId" ||
        key === "userId" ||
        key === "userPhone" ||
        key === "action" ||
        key === "status"
      ) {
        if (selected[0] != undefined && selected[0] !== "") {
          formattedItems[key] = selected[0]
        }
      }
    })
    return formattedItems
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const nextFilters = {
      ...searchItemsMap(Object.keys(filters), Object.values(filters)),
      orderBy: sorter?.column?.dataIndex,
      isDesc: sorter?.order ? sorter.order === "ascend" : undefined,
    }
    setTableFilters(nextFilters)
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
    load(pagination.current, pagination.pageSize, nextFilters)
  }

  const showDeletedItems = (value) => {
    setIsDeleted(value)
    setPage(1)
    load(1, pageSize, tableFilters, value)
  }

  const rows = list?.data?.value?.rows?.map((row) => ({
    ...row,
    action: ACTION_TITLES[row.action] || row.action,
    status: statusLabel(row.status),
    error:
      row.status === 0 || row.status === "0" ? row.error || "" : "",
    dateCreate: row.dateCreate
      ? dayjs(row.dateCreate).format("DD.MM.YYYY HH:mm")
      : "",
  }))

  return (
    <AdminTable
      scroll={{ x: 1200, y: 600 }}
      page={page}
      setPage={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onChange={handleTableChange}
      loading={loading}
      columns={list?.data?.value?.columns?.length ? list : FALLBACK_COLUMNS}
      rows={rows}
      total={list?.data?.value?.totalCount}
      items={[]}
      title={() => (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            minHeight: 60,
            padding: "0 16px",
            background: "#fff",
          }}
        >
          <Switch
            checkedChildren={<DeleteOutlined />}
            unCheckedChildren={<DeleteOutlined />}
            onChange={showDeletedItems}
            style={{ transform: "scale(1.1)" }}
          />
        </div>
      )}
    />
  )
}

export default LockerActions
